import {$dom} from "../../helpers/dom";
import Component from "../../classes/Component";
import {$events} from "../../helpers/events";

const {get} = $dom

const offcanvasOrderSelector = '.js-offcanvas-order'
const offcanvasOrderOffcanvasSelector = '.js-offcanvas-order-detail'
const offcanvasOrderOffcanvasHeaderSelector = '.js-offcanvas-order-detail-header'

// этот заказ мы получили из fetch
const orderDetail = [{
    id: 4,
    title: 'Заказ 45654 от 25.08.2021',
    coast: '6 500 ₽',
    count: '5 товаров',
    type: 'Доставлен',
    orders: [
        {title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '1 шт'},
        {title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '380 ₽', count: '1 шт'},
        {title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '4 шт'},
    ]
}]

export default function () {
    const getOrders = (item) => {
        let resultHTML = ''

        for (let i = 0; i < item.orders.length; i++) {
            resultHTML += `
                <div class="col-md-4 col-12 mb-md-0 mb-sm-4 mb-4">
                    <div class="d-flex">
                        <img src="../img/order/image.jpg" width='75' height='60' alt="">
                        
                        <div class="ms-1">
                            <p class="mb-3 text--regular">${item.orders[i].title}</p>
                            
                            <div class="d-flex">
                                <p class="me-3 text--regular">${item.orders[i].count}</p>
                                
                                <p class="text--regular">${item.orders[i].coast}</p>
                            </div>
                        </div>
                    </div>
                </div>
            `
        }

        return resultHTML
    }

    const renderDetailOrder = () => {
        const HTMLStart = ``
        const HTMLEnd = ''

        let HTML = ''

        orderDetail.forEach(item => {
            HTML += `
                <div class="pb-5 js-accordion-item">
                    <div>                    
                        <div class="row row-cols-3 gy-3">
                             ${getOrders(item)}                         
                        </div> 
                        
                        <div class="d-flex justify-content-between mt-3 ms-4 me-4">
                            <p class="text--medium">Начислено бонусов</p>
                            <p class="text--medium">15</p>
                        </div>         
                        
                        <div class="d-flex justify-content-between mt-3 ms-4 me-4">
                            <p class="text--medium">Доставка курьером Ozon</p>
                            <p class="text--medium">150 ₽</p>
                        </div>   
                        
                        <div class="d-flex justify-content-between px-4 py-3 orders__item-accordion-price">
                            <p class="text--medium mb-0 text--extra-large">Всего</p>
                            <p class="text--medium mb-0 text--extra-large">6 500 ₽</p>
                        </div>    
                        
                        <div class="row mt-5 mx-1 flex-md-row flex-sm-column flex-column">
                            <div class="col-md-3 col-sm-12 col-12">
                                <p class="text--gray mb-sm-2 mb-2 mb-md-4">Получатель</p>
                                <p class="mb-0">Владимиров Владислав</p>
                                <p class="mb-0 text--regular">+ 7 (898) 654-65-56</p>
                            </div>
                            
                            <div class="col-12 d-md-none d-sm-block d-block mt-3 mb-3">
                                <hr>
                            </div>
                            
                            <div class="col-md-4 col-sm-12 col-12 d-flex justify-content-start flex-column align-items-md-end align-items-sm-start align-items-start">
                                <div>
                                    <p class="text--gray mb-sm-2 mb-2 mb-md-4">Адрес доставки</p>
                                    <p class="mb-0">г. Москва, берсеневская наб., 16/1, 65</p>
                                    <p class="mb-0 text--regular">Курьер Ozon</p>
                                </div>
                            </div>
                            
                            <div class="col-12 d-md-none d-sm-block d-block mt-3 mb-3">
                                <hr>
                            </div>
                            
                            <div class="col-md-2 col-sm-12 col-12 d-flex justify-content-start flex-column align-items-md-end align-items-sm-start align-items-start">
                                <div>
                                    <p class="text--gray mb-sm-2 mb-2 mb-md-4">Оплата</p>
                                    <p class="mb-0">Картой онлайн</p>
                                </div>
                            </div>
                            
                            <div class="col-md-3 orders__offcanvas-button col-sm-12 col-12 align-self-center d-flex justify-content-start flex-column align-items-end pe-0 align-items-sm-start align-items-start mb-3 mt-md-0 mt-sm-5 mt-5">
                                <button class="orders__information-button button--default rounded w-100">Оплатить сейчас</button>
                            </div>
                        </div> 
                    </div>
                </div>
                `
        })

        HTML = HTMLStart + HTML + HTMLEnd

        const HTMLHeader = `
            <div class="ps-5">
                <h3 class="">Заказ 45654 от 25.08.2021</h3>
                <p class="text--regular text--gray">Доставлен</p>
            </div>
        `

        get(offcanvasOrderOffcanvasSelector).innerHTML = HTML
        get(offcanvasOrderOffcanvasHeaderSelector).innerHTML = HTMLHeader
    }

    const handleOpenOffcanvas = (e) => {
        // const id = e.target.closest(offcanvasOrderSelector).dataset.id
        // id, кнопкки, на которую мы нажали

        renderDetailOrder()
    }

    return new Component({
        name: 'dynamicRenderOffcanvas',
        requiredTargets: [offcanvasOrderSelector],
        onInit() {
            $events.delegate.on('click', offcanvasOrderSelector, handleOpenOffcanvas)
        },
        onDestroy() {
            console.log('dynamicRenderOffcanvas')
        },
    })

}